import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {firstAuthorizedRoute, TranslationKeys} from 'utils/constants/routeConstants';
import {IStore} from 'redux/interface';
import {startLoginAction} from 'redux/auth/authAsyncActions';

import MeetYourTeam from 'components/meet-your-team';
import MainArea from 'components/main-area';

import './styles.scss';

export const Home: React.FunctionComponent = () => {
  const {
    auth0User,
    isFinishAuthorization
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useGetTranslations({
    translationKey: TranslationKeys.Home
  });
  const {state: appLocState} = useLocation();

  useEffect(() => {
    if (auth0User) {
      if (appLocState) {
        navigate(appLocState.from, {replace: true});
      } else {
        navigate(firstAuthorizedRoute, {replace: true});
      }
    }
    if (!auth0User && appLocState && isFinishAuthorization) {
      if (appLocState) {
        dispatch(startLoginAction(appLocState.from.pathname + appLocState.from.hash));
      }
    }
  }, [auth0User, appLocState, isFinishAuthorization]);

  return <div className="home">
    <h1 className="visually-hidden">
      <FormattedMessage
        id={'gritx.home.access.title'}
        defaultMessage={'Home page Libe website'}
      />
    </h1>
    <MainArea/>
    {/* <MeetYourTeam/>*/}
  </div>;
};
